<script lang="ts">
	import MdiArrowLeft from '~icons/mdi/arrow-left';
	import MdiArrowRight from '~icons/mdi/arrow-right';

	import PortableText from '$components/PortableText/PortableText.svelte';

	import type { PageData } from './$types';
	interface Props {
		data: PageData;
	}

	let { data }: Props = $props();

	let { event_data, nextEvent, previousEvent } = $derived(data);
</script>

<svelte:head>
	<title>{event_data.name}</title>
	<meta
		name="description"
		content={`${event_data.startTime}${
			event_data.location ? ' at ' + event_data.location.join(', ') : ''
		}`}
	/>
</svelte:head>

<div class="grid min-h-full grid-rows-1">
	<div>
		<!-- eslint-disable svelte/no-navigation-without-resolve -->
		<a data-sveltekit-preload-data href="/events" class="text-link">Events</a>

		<h1 class="page-title mb-4">{event_data.name}</h1>
		<section id="event-details" class="space-y-4">
			<div class="text-center">
				{event_data.startTime}
			</div>
			<address class="text-center">
				{#if event_data.location}
					<!-- eslint-disable-next-line svelte/require-each-key -->
					{#each event_data.location as locLine}
						{locLine}<br />
					{/each}
				{:else}
					location tbc
				{/if}
			</address>
			{#if event_data.worksPerformed}
				<div class="text-center">
					<h2 class="font-bold">Pieces performed</h2>
					<ul>
						<!-- eslint-disable-next-line svelte/require-each-key -->
						{#each event_data.worksPerformed as performedWork}
							<li class="py-1">
								{#if performedWork._type === 'work'}
									<a
										data-sveltekit-preload-data
										href="/works/{performedWork.workReference.slug}"
										class="text-link-main underline"
									>
										{performedWork.workReference.name}
									</a>
								{:else}
									<span>
										{performedWork.name}
									</span>
								{/if}
							</li>
						{/each}
					</ul>
				</div>
			{/if}
		</section>
		<section class="mt-4 pt-4">
			{#if event_data.content}
				<article class="prose-text-link-main prose mx-auto">
					<PortableText value={event_data.content} />
				</article>
			{/if}
		</section>
	</div>

	<div class="row-start-2 row-end-3 mt-4 grid grid-cols-2 pt-4">
		<span class="">
			{#if previousEvent}
				<a data-sveltekit-preload-data class="text-link" href="./{previousEvent.slug}">
					<MdiArrowLeft class="mr-1 inline" />{previousEvent.name}
				</a>
			{/if}
		</span>
		<span class="text-right">
			{#if nextEvent}
				<a data-sveltekit-preload-data class="text-link" href="./{nextEvent.slug}">
					{nextEvent.name}<MdiArrowRight class="ml-1 inline" />
				</a>
			{/if}
		</span>
	</div>
</div>
